import {BackBtnService} from "./back-btn.service";

export const BackBtnInjectables: Array<any> = [
  {provide: BackBtnService, useClass: BackBtnService},
];
